import { FactionRank } from "@1games-ru/region-shared/dist/types/faction/faction";
import { useCallback } from "react";
import { FactionEnum } from "@/domains/faction/constants/factionEnum";
import { factionsList } from "@/domains/faction/helpers/factionsList";
import FactionRankItem from "@/domains/faction/components/FactionRankItem";

type Props = {
  faction: FactionEnum;
  activeRank: number;
  setActiveRank: (idx: number) => void;
  setRankAccesses: (idx: number) => void;
  list: FactionRank[];
};

export default function FactionListAside({
  faction,
  activeRank,
  setActiveRank,
  setRankAccesses,
  list,
}: Props) {
  const onClick = useCallback(
    (idx: number) => {
      setActiveRank(idx);
      setRankAccesses(idx);
    },
    [setActiveRank, setRankAccesses],
  );

  return (
    <div className="relative flex flex-col w-[19.875rem] h-full min-h-0">
      <div className="absolute z-2 bottom-0 left-0 w-[calc(100%-2rem)] h-7 bg-gradient-to-t from-dark-900 to-transparent pointer-events-none" />
      <div className="absolute z-2 bottom-0 left-0 w-[calc(100%-2rem)] h-5 bg-gradient-to-t from-dark-900 to-transparent pointer-events-none" />
      <div className="absolute top-0 left-0 bottom-0 w-[calc(100%-1.5rem)] pb-5 pr-1.5 overflow-y-auto overflow-x-clip [--scrollbar-track-bg:#181818] [--scrollbar-thumb-bg:#434242] [scrollbar-gutter:stable]">
        <div>
          {list.map((item, idx) => (
            <FactionRankItem
              key={item.id}
              idx={idx}
              text={item.name}
              isActive={idx === activeRank}
              gradient={factionsList[faction]?.gradient}
              onClick={onClick}
              number={list.length - idx}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
